export default function() {
    const langBtns = document.querySelectorAll('.c-language__btn');

    if (langBtns.length) {
        langBtns.forEach(el => {
            el.addEventListener('click', function(event) {
                event.stopPropagation();
                el.parentElement.classList.toggle('open');
            });
        });
        document.addEventListener('click', function() {
            langBtns.forEach(el => {
                el.parentElement.classList.remove('open');
            });
        });
    }
}
